import { doHttp } from '../util/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../util/constants'

/**
 * 登录
 * @param account
 * @param password
 * @return {*}
 */
export function apiLogin (phone, password) {
  let params = {
    phone,
    password
  }

  return doHttp('/user/v1/login', HTTP_TYPE_POST, params)
}

/**
 * 用户注册接口
 * @param params
 * @returns {*}
 */
export function apiRegister (params) {
  return doHttp('/user/v1/regist', HTTP_TYPE_POST, params)
}

/**
 * 用户注销接口
 * @returns {*}
 */
export function apiLogout () {
  return doHttp('/user/v1/authApi/logout', HTTP_TYPE_POST)
}

/**
 * 获取未读通知数接口
 * @returns {*}
 */
export function apiUnreadNoticeCount () {
  return doHttp('/notice/v1/authApi/getUnreadCount', HTTP_TYPE_POST)
}

/**
 * 获取用户信息
 * @returns {*}
 */
export function apiUserInfo() {
  return doHttp('/user/v1/authApi/getUserInfo', HTTP_TYPE_POST)
}

/**
 * 更新用户头像
 * @param avatar
 * @returns {*}
 */
export function apiChangeUserAvatar(avatar) {
  return doHttp('/user/v1/authApi/changeUserAvatar', HTTP_TYPE_POST, { avatar })
}

/**
 * 更新用户昵称
 * @param nickName
 * @returns {*}
 */
export function apiChangeUserNickName(nickName) {
  return doHttp('/user/v1/authApi/changeUserNickName', HTTP_TYPE_POST, { nickName })
}

/**
 * 添加实名认证接口，只有当实名认证不存在时，才能调用此接口
 * @param params
 * @returns {*}
 */
export function apiAddIdentityCertification(params) {
  return doHttp('/certification/v1/authApi/addIdentityCertification', HTTP_TYPE_POST, params)
}

/**
 * 编辑实名认证接口，只有当实名认证被拒绝后，才能调用此接口重新修改提交。
 * @param params
 * @returns {*}
 */
export function apiEditIdentityCertification(params) {
  return doHttp('/certification/v1/authApi/editIdentityCertification', HTTP_TYPE_POST, params)
}

/**
 * 获取实名认证信息
 * @returns {*}
 */
export function apiIdentityCertification() {
  return doHttp('/certification/v1/authApi/getIdentityCertification', HTTP_TYPE_POST)
}

/**
 * 找回密码接口，调用成功后，登录凭证会失效，需要重新登录
 * @param params
 * @returns {*}
 */
export function apiFindPassword(params) {
  return doHttp('/user/v1/findPassword', HTTP_TYPE_POST, params)
}



// WEBPACK FOOTER //
// ./src/api/user.js